export default __webpack_public_path__ + "static/media/widget_watchbox_vpmnq60f_sell.d94d8d8b.mp3";